import { createAnalyticsStore } from "@/store/Analytic/create-chart-store";

export const useCountryStatDomainBlocksStore = createAnalyticsStore(
  "countryStatDomainBlocks",
  "Analytics/top/domain/:projectId"
);